module.exports = __webpack_public_path__ + "16462e8a145d7418b5d6a22a60b2dbba.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/theater.jpg
// module id = 640
// module chunks = 0